import React, { PureComponent } from 'react';
import MediaQuery from 'react-responsive';
import { fetchProducts } from './previousProductsUtil';
import PreviousProductsDesktop from './PreviousProductsDesktop';
import PreviousProductsMobile from './PreviousProductsMobile';
import NoPreviousProducts from './NoPreviousProducts';

class PreviouslyViewedProducts extends PureComponent {
  constructor() {
    super();
    this.state = {
      currentPage: 1,
      isLoading: true,
      pageSize: 5,
      products: [],
      totalPages: 3,
    };

    this.handlePageTransition = this.handlePageTransition.bind(this);
    this.hasNext = this.hasNext.bind(this);
    this.hasPrevious = this.hasPrevious.bind(this);
  }

  async componentDidMount() {
    const products = await fetchProducts();
    this.initializeComponent(products);
  }

  async initializeComponent(products) {
    const totalItems = products.length;
    const totalPages = Math.ceil(totalItems / 5);

    if (Array.isArray(products)) this.setState({ products });

    this.setState({ totalPages, isLoading: false });
  }

  hasNext() {
    const { currentPage, totalPages } = this.state;
    return currentPage < totalPages;
  }

  hasPrevious() {
    return this.state.currentPage > 1;
  }

  handlePageTransition(shouldTransition, nextPage) {
    if (shouldTransition()) this.setState({ currentPage: nextPage });
  }

  render() {
    const { isLoading, products, currentPage, pageSize } = this.state;
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = (currentPage - 1) * pageSize + pageSize;

    if (products.length > 0) {
      return (
        <div>
          <MediaQuery minDeviceWidth={1224}>
            <PreviousProductsDesktop
              hasNext={this.hasNext}
              hasPrevious={this.hasPrevious}
              isLoading={isLoading}
              products={products.slice(startIndex, endIndex)}
              onNext={() => this.handlePageTransition(this.hasNext, currentPage + 1)}
              onPrevious={() => this.handlePageTransition(this.hasPrevious, currentPage - 1)}
            />
          </MediaQuery>
          <MediaQuery maxDeviceWidth={1224}>
            <PreviousProductsMobile
              hasNext={this.hasNext}
              isLoading={this.state.isLoading}
              products={products.slice(0, endIndex)}
              onNext={() => this.handlePageTransition(this.hasNext, currentPage + 1)}
            />
          </MediaQuery>
        </div>
      );
    }
    return <NoPreviousProducts isLoading={isLoading} />;
  }
}

export default PreviouslyViewedProducts;
